import React from "react";
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  alpha,
  Alert,
} from "@mui/material";
import { formatAmount } from "../../../../../../utils/hooks/dataHandler";

const totalRowStyle = {
  fontWeight: 700,
  color: "text.primary",
  py: 2,
  borderTop: "2px solid",
  borderColor: (theme) => alpha(theme.palette.divider, 0.3),
  bgcolor: (theme) => alpha(theme.palette.primary.main, 0.04),
};

const ReconciliationDisplay = ({
  adjustment,
  originalTotal,
  adjustedTotal,
}) => {
  // Only show if adjustment was applied AND there's a difference
  if (!adjustment || !adjustment.adjusted) {
    return null;
  }

  // Check if there's actually a difference to show
  const difference = Math.abs(adjustedTotal - originalTotal);
  if (difference < 0.01) {
    return null;
  }

  return (
    <Box sx={{ mt: 3 }}>
      <Alert
        severity='info'
        sx={{
          mb: 3,
          borderRadius: 2,
          bgcolor: (theme) => alpha(theme.palette.info.main, 0.08),
          border: "1px solid",
          borderColor: (theme) => alpha(theme.palette.info.main, 0.2),
        }}
      >
        <Typography variant='subtitle2' gutterBottom>
          <strong>Adjustment Disclosure</strong>
        </Typography>
        <Typography variant='body2'>
          An adjustment has been applied to reconcile the total principal paid
          to the asset cost. The final Year of Assessment (YA) has been adjusted
          to ensure the total matches the asset cost.
        </Typography>
      </Alert>

      <Box>
        <Typography variant='h6' fontWeight={600} gutterBottom sx={{ mb: 2 }}>
          Reconciliation Details
        </Typography>
        <TableContainer
          component={Paper}
          elevation={0}
          sx={{
            borderRadius: 2,
            border: "1px solid",
            borderColor: (theme) => alpha(theme.palette.divider, 0.1),
          }}
        >
          <Table size='small'>
            <TableHead>
              <TableRow
                sx={{
                  bgcolor: (theme) => alpha(theme.palette.primary.main, 0.03),
                }}
              >
                <TableCell
                  sx={{
                    fontWeight: 600,
                    color: "text.secondary",
                    borderBottom: "2px solid",
                    borderColor: (theme) => alpha(theme.palette.divider, 0.1),
                    py: 2,
                  }}
                >
                  Description
                </TableCell>
                <TableCell
                  align='right'
                  sx={{
                    fontWeight: 600,
                    color: "text.secondary",
                    borderBottom: "2px solid",
                    borderColor: (theme) => alpha(theme.palette.divider, 0.1),
                    py: 2,
                  }}
                >
                  Amount
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell sx={{ py: 1.5 }}>Original Total Principal</TableCell>
                <TableCell align='right' sx={{ py: 1.5 }}>
                  {formatAmount(originalTotal)}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ py: 1.5 }}>Adjusted Total Principal</TableCell>
                <TableCell align='right' sx={{ py: 1.5 }}>
                  {formatAmount(adjustedTotal)}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={totalRowStyle}>Difference</TableCell>
                <TableCell align='right' sx={totalRowStyle}>
                  {formatAmount(difference)}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
};

export default ReconciliationDisplay;
